import { render, staticRenderFns } from "./ReportSuspect.vue?vue&type=template&id=17579b2f&scoped=true&"
import script from "./ReportSuspect.vue?vue&type=script&lang=js&"
export * from "./ReportSuspect.vue?vue&type=script&lang=js&"
import style0 from "./ReportSuspect.vue?vue&type=style&index=0&id=17579b2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17579b2f",
  null
  
)

export default component.exports